import React from 'react';

import { useBrowserContentColor } from '@/hooks/useBrowserContentColor';
import { webCampaign } from '@/modules/webCampaign';
import LayoutDefault from '@/pages/Onboarding/Layouts/Default/Default';
import LayoutDevmode from '@/pages/Onboarding/Layouts/Devmode/Devmode';
import LayoutOwnAI from '@/pages/Onboarding/Layouts/OwnAI/OwnAI';
import LayoutOwnAI_Dominate from '@/pages/Onboarding/Layouts/OwnAI_Dominate/OwnAI_Dominate';
import LayoutOwnAI_DominateV2 from '@/pages/Onboarding/Layouts/OwnAI_DominateV2/OwnAI_DominateV2';
import LayoutOwnAI_FsGrAIPh from '@/pages/Onboarding/Layouts/OwnAI_FsGrAIPh/OwnAI_FsGrAIPh';
import LayoutOwnAI_FsGrAITl from '@/pages/Onboarding/Layouts/OwnAI_FsGrAITl/OwnAI_FsGrAITl';
import LayoutOwnAI_FsGrFlAI from '@/pages/Onboarding/Layouts/OwnAI_FsGrFlAI/OwnAI_FsGrFlAI';
import LayoutOwnAI_ICaEm from '@/pages/Onboarding/Layouts/OwnAI_ICaEm/OwnAI_ICaEm';
import LayoutOwnAI_ICaTO from '@/pages/Onboarding/Layouts/OwnAI_ICaTO/OwnAI_ICaTO';
import LayoutOwnAI_ICbEm from '@/pages/Onboarding/Layouts/OwnAI_ICbEm/OwnAI_ICbEm';
import LayoutOwnAI_Ons from '@/pages/Onboarding/Layouts/OwnAI_Ons/OwnAI_Ons';
import LayoutOwnAI_Paymentless from '@/pages/Onboarding/Layouts/OwnAI_Paymentless/OwnAIPaymentless';
import LayoutOwnAI_Pool from '@/pages/Onboarding/Layouts/OwnAI_Pool/OwnAI_Pool';
import LayoutOwnAI_Trans from '@/pages/Onboarding/Layouts/OwnAI_Trans/OwnAI_Trans';
import LayoutOwnAI_W from '@/pages/Onboarding/Layouts/OwnAI_W/OwnAI_W';
import LayoutOwnAICompatibility from '@/pages/Onboarding/Layouts/OwnAICompatibility/OwnAICompatibility';
import LayoutOwnAIConstructor from '@/pages/Onboarding/Layouts/OwnAIConstructor/OwnAIConstructor';
import LayoutOwnAIMan from '@/pages/Onboarding/Layouts/OwnAIMan/OwnAIMan';
import LayoutOwnAIMan_Ce from '@/pages/Onboarding/Layouts/OwnAIMan_Ce/OwnAIMan_Ce';
import LayoutOwnAIMan_FLs from '@/pages/Onboarding/Layouts/OwnAIMan_FLs/OwnAIMan.tsx';
import LayoutOwnAIMan_FLsMg from '@/pages/Onboarding/Layouts/OwnAIMan_FLsMg/OwnAIMan';
import LayoutOwnAIMan_FLsTg from '@/pages/Onboarding/Layouts/OwnAIMan_FLsTg/OwnAIMan';
import LayoutOwnAIMan_G from '@/pages/Onboarding/Layouts/OwnAIMan_G/OwnAIMan_G';
import LayoutOwnAIMan_ICaEm from '@/pages/Onboarding/Layouts/OwnAIMan_ICaEm/OwnAIMan_ICaEm';
import LayoutOwnAIMan_ICaTO from '@/pages/Onboarding/Layouts/OwnAIMan_ICaTO/OwnAIMan_ICaTO';
import LayoutOwnAIMan_ICbEm from '@/pages/Onboarding/Layouts/OwnAIMan_ICbEm/OwnAIMan_ICbEm';
import LayoutOwnAIMan_LS from '@/pages/Onboarding/Layouts/OwnAIMan_LS/OwnAIMan_LS';
import LayoutOwnAIMan_LSaN from '@/pages/Onboarding/Layouts/OwnAIMan_LSaN/OwnAIMan_LSaN';
import LayoutOwnAIMan_Maxim from '@/pages/Onboarding/Layouts/OwnAIMan_Maxim/OwnAIMan_Maxim';
import LayoutOwnAIMan_Paymentless from '@/pages/Onboarding/Layouts/OwnAIMan_Paymentless/OwnAIManPaymentless';
import LayoutOwnAIMan_Roleplay from '@/pages/Onboarding/Layouts/OwnAiMan_Roleplay/OwnAIMan_Roleplay';
import OwnAIMan_Roleplay_NaP from '@/pages/Onboarding/Layouts/OwnAiMan_Roleplay_NaP/OwnAIMan_Roleplay_NaP';
import LayoutOwnAIMan_ScS from '@/pages/Onboarding/Layouts/OwnAIMan_ScS/LayoutOwnAIMan-ScS';
import LayoutOwnAIMan_SPaE from '@/pages/Onboarding/Layouts/OwnAIMan_SPaE/OwnAIMan_SPaE';
import LayoutOwnAIMan_SPaN from '@/pages/Onboarding/Layouts/OwnAIMan_SPaN/OwnAIMan_SPaN';
import LayoutOwnAIMan_TM from '@/pages/Onboarding/Layouts/OwnAIMan_TM/OwnAIMan_TM';
import LayoutOwnAIMan_Trans_L from '@/pages/Onboarding/Layouts/OwnAIMan_Trans_L/OwnAIMan_Trans_L';
import LayoutOwnAIMan_Trans_S from '@/pages/Onboarding/Layouts/OwnAIMan_Trans_S/OwnAIMan_Trans_S';
import LayoutOwnAIMultiGender from '@/pages/Onboarding/Layouts/OwnAIMultiGender/OwnAIMultiGender';
import LayoutOwnAIMultiGender_AIO_G from '@/pages/Onboarding/Layouts/OwnAIMultiGender_AIO_G/OwnAIMultiGender_AIO_G';
import LayoutOwnAIMultiGender_FM from '@/pages/Onboarding/Layouts/OwnAIMultiGender_FM/OwnAIMultiGender_FM';
import LayoutOwnAIMultiGender_FM_BG from '@/pages/Onboarding/Layouts/OwnAIMultiGender_FM_BG/OwnAIMultiGender_FM_BG';
import LayoutOwnAIMultiGender_FM_G from '@/pages/Onboarding/Layouts/OwnAIMultiGender_FM_G/OwnAIMultiGender_FM_G';
import LayoutOwnAIMultiGenderForest from '@/pages/Onboarding/Layouts/OwnAIMultiGenderForest/OwnAIMultiGenderForest';
import LayoutOwnAIMultiGenderLure from '@/pages/Onboarding/Layouts/OwnAIMultiGenderLure/OwnAIMultiGenderLure';
import LayoutOwnAIMultiGenderSafe from '@/pages/Onboarding/Layouts/OwnAIMultiGenderSafe/OwnAIMultiGenderSafe';
import LayoutOwnAIMultiGenderSafeV2 from '@/pages/Onboarding/Layouts/OwnAIMultiGenderSafeV2/OwnAIMultiGenderSafeV2';
import LayoutOwnAIRoleplayRooms from '@/pages/Onboarding/Layouts/OwnAIRoleplayRooms/OwnAIRoleplayRooms';
import LayoutOwnAISecond from '@/pages/Onboarding/Layouts/OwnAISecond/OwnAISecond';
import LayoutOwnAISecondVideo from '@/pages/Onboarding/Layouts/OwnAISecondVideo/OwnAISecondVideo';
import LayoutReplikaPersonalized from '@/pages/Onboarding/Layouts/ReplikaPersonalized/ReplikaPersonalized';
import LayoutReplikaRelationships from '@/pages/Onboarding/Layouts/ReplikaRelationships/ReplikaRelationships';
import LayoutReplikaShort from '@/pages/Onboarding/Layouts/ReplikaShort/ReplikaShort';
import LayoutReplikaShortNoAi from '@/pages/Onboarding/Layouts/ReplikaShortNoAi/ReplikaShortNoAi';
import LayoutReplikaUserDataRelationships from '@/pages/Onboarding/Layouts/ReplikaUserDataRelationships/ReplikaUserDataRelationships';

const OnboardingFlowPage: React.FC = () => {
  useBrowserContentColor();

  switch (webCampaign.setup.layout) {
    // Dev layouts
    case 'devmode': {
      return <LayoutDevmode />;
    }
    // Production layouts
    case 'own-ai-multigender': {
      return <LayoutOwnAIMultiGender />;
    }
    case 'own-ai-multigender-fm': {
      return <LayoutOwnAIMultiGender_FM />;
    }
    case 'own-ai-multigender-fm-g': {
      return <LayoutOwnAIMultiGender_FM_G />;
    }
    case 'own-ai-multigender-aio-g': {
      return <LayoutOwnAIMultiGender_AIO_G />;
    }
    case 'own-ai-multigender-fm-bg': {
      return <LayoutOwnAIMultiGender_FM_BG />;
    }
    case 'own-ai-multigender-lure': {
      return <LayoutOwnAIMultiGenderLure />;
    }
    case 'own-ai-multigender-safe': {
      return <LayoutOwnAIMultiGenderSafe />;
    }
    case 'own-ai-multigender-safe-v2': {
      return <LayoutOwnAIMultiGenderSafeV2 />;
    }
    case 'own-ai-multigender-forest': {
      return <LayoutOwnAIMultiGenderForest />;
    }
    case 'own-ai': {
      return <LayoutOwnAI />;
    }
    case 'own-ai-w': {
      return <LayoutOwnAI_W />;
    }
    case 'own-ai-ons': {
      return <LayoutOwnAI_Ons />;
    }
    case 'own-ai-trans': {
      return <LayoutOwnAI_Trans />;
    }
    case 'own-ai-domination': {
      return <LayoutOwnAI_Dominate />;
    }
    case 'own-ai-domination-v2': {
      return <LayoutOwnAI_DominateV2 />;
    }
    case 'own-ai-FsGrFlAI': {
      return <LayoutOwnAI_FsGrFlAI />;
    }
    case 'own-ai-FsGrAITl': {
      return <LayoutOwnAI_FsGrAITl />;
    }
    case 'own-ai-FsGrAIPh': {
      return <LayoutOwnAI_FsGrAIPh />;
    }
    case 'own-ai-ICaTO': {
      return <LayoutOwnAI_ICaTO />;
    }
    case 'own-ai-ICbEm': {
      return <LayoutOwnAI_ICbEm />;
    }
    case 'own-ai-ICaEm': {
      return <LayoutOwnAI_ICaEm />;
    }
    case 'own-ai-man': {
      return <LayoutOwnAIMan />;
    }
    case 'own-ai-man-g': {
      return <LayoutOwnAIMan_G />;
    }
    case 'own-ai-man-ce': {
      return <LayoutOwnAIMan_Ce />;
    }
    case 'own-ai-man-fls': {
      return <LayoutOwnAIMan_FLs />;
    }
    case 'own-ai-man-fls-mg': {
      return <LayoutOwnAIMan_FLsMg />;
    }
    case 'own-ai-man-fls-tg': {
      return <LayoutOwnAIMan_FLsTg />;
    }
    case 'own-ai-man-scs': {
      return <LayoutOwnAIMan_ScS />;
    }
    case 'own-ai-man-SPaN': {
      return <LayoutOwnAIMan_SPaN />;
    }
    case 'own-ai-man-SPaE': {
      return <LayoutOwnAIMan_SPaE />;
    }
    case 'own-ai-man-LSaN': {
      return <LayoutOwnAIMan_LSaN />;
    }
    case 'own-ai-man-ls': {
      return <LayoutOwnAIMan_LS />;
    }
    case 'own-ai-man-ICbEm': {
      return <LayoutOwnAIMan_ICbEm />;
    }
    case 'own-ai-man-ICaEm': {
      return <LayoutOwnAIMan_ICaEm />;
    }
    case 'own-ai-man-ICaTO': {
      return <LayoutOwnAIMan_ICaTO />;
    }
    case 'own-ai-man-paymentless': {
      return <LayoutOwnAIMan_Paymentless />;
    }
    case 'own-ai-paymentless': {
      return <LayoutOwnAI_Paymentless />;
    }
    case 'own-ai-second': {
      return <LayoutOwnAISecond />;
    }
    case 'own-ai-second-video': {
      return <LayoutOwnAISecondVideo />;
    }
    case 'replika-personalized': {
      return <LayoutReplikaPersonalized />;
    }
    case 'replika-short':
    case 'replika-short-v2': {
      return <LayoutReplikaShort />;
    }
    case 'replika-short-no-ai': {
      return <LayoutReplikaShortNoAi />;
    }
    case 'replika-relationships': {
      return <LayoutReplikaRelationships />;
    }
    case 'replika-user-data-relationships': {
      return <LayoutReplikaUserDataRelationships />;
    }
    case 'own-ai-man-roleplay': {
      return <LayoutOwnAIMan_Roleplay />;
    }
    case 'own-ai-man-roleplay-nap': {
      return <OwnAIMan_Roleplay_NaP />;
    }
    case 'own-ai-man-trans-l': {
      return <LayoutOwnAIMan_Trans_L />;
    }
    case 'own-ai-man-trans-s': {
      return <LayoutOwnAIMan_Trans_S />;
    }
    case 'own-ai-man-maxim': {
      return <LayoutOwnAIMan_Maxim />;
    }
    case 'own-ai-man-tm': {
      return <LayoutOwnAIMan_TM />;
    }
    case 'own-ai-constructor': {
      return <LayoutOwnAIConstructor />;
    }
    case 'own-ai-compatibility': {
      return <LayoutOwnAICompatibility />;
    }
    case 'own-ai-roleplay-rooms': {
      return <LayoutOwnAIRoleplayRooms />;
    }
    case 'own-ai-pool': {
      return <LayoutOwnAI_Pool />;
    }
    default: {
      return <LayoutDefault />;
    }
  }
};

export default OnboardingFlowPage;
